module.exports = __webpack_public_path__ + "static/media/champagne-fles.83e668e6.png";